// extracted by mini-css-extract-plugin
module.exports = {"Section5":"Section5_Section5__wTl0l","Layout1":"Section5_Layout1__RIhc8"};